if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Init.
     */
    init() {
      for (const link of this.querySelectorAll('[data-js-tab-link-index]')) {
        link.addEventListener('click', this.onClick.bind(this));
      }
    }

    /**
     * On click.
     *
     * @param {Event} event
     */
    onClick(event) {
      const { target } = event;
      const targetTab = this.querySelector(
        `[data-js-tab-index="${target.getAttribute(
          'data-js-tab-link-index',
        )}"]`,
      );

      if (!targetTab) return;

      this.querySelector('[data-js-tab-link-index].active').classList.remove(
        'active',
      );
      this.querySelector('[data-js-tab-index].active').classList.remove(
        'active',
      );
      target.classList.add('active');
      targetTab.classList.add('active');
    }
  }
  customElements.define('tabs-component', TabsComponent);
}
